export default __webpack_public_path__ + "static/media/demo.6addb66e.png";